import React, { PureComponent } from 'react';
import styles from './DetailModal.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import http from '@/assets/api/http';
import moment from 'moment';
import { Modal, Input, Form, message } from 'antd';
import { XOKButton, XMediaFn } from '@/components/xqxc_ui';
import model from '@/reducers/aftersale/suggestions/model';

const { TextArea } = Input;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 1 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

class ProducDetails extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
            visible: this.props.visible,
        };
    }
    formRef = React.createRef();
    componentDidMount() {
        this.props.getideaBackInfo({ id: this.props.data.id });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.ideaBackInfo) {
            this.formRef.current.setFieldsValue({ processOpinion: nextProps.ideaBackInfo.processOpinion });
        }
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }

    _handleOk = () => {
        this.formRef.current.validateFields().then(fieldsValue => {
            const { ideaBackInfo: { id, processState } } = this.props;
            const param = {
                id,
                ...fieldsValue,
            };
            if (processState === '已处理') {
                message.warn('已处理不可再处理!');
            } else {
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.IdeaBackService.executeIdeaBack', param, 'POST')
                    .then(() => {
                        message.success('处理成功。');
                        this.setState({
                            visible: false,
                        });
                        this.props.closeMode(true);
                        this.props.refresh();
                    }).catch((reject) => {
                        message.error(reject.message);
                    });
            }

        });
    }

    render() {
        const { visible, confirmLoading, title } = this.state;
        const { ideaBackInfo = {} } = this.props;
        return (
            <Modal
                width={800}
                height={800}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div style={{ height: 700, overflowY: 'auto' }}>
                    <div className={styles.orderInfo} >
                        <div className={`${styles.items} ${styles.layout}`}>
                            <div className={styles.flex}>
                                <p><label>会员昵称:</label><span>{ideaBackInfo.accountNickname}</span></p>
                                <p><label>反馈类型:</label><span>{ideaBackInfo.ideaBackCode}</span></p>
                                <p><label>反馈渠道:</label><span>{ideaBackInfo.ideaBackSystemTypeDesc}</span></p>
                            </div>
                            <div className={styles.flex}>
                                <p><label>手机号:</label><span>{ideaBackInfo.consigneeMobile}</span></p>
                                <p><label>提交时间:</label><span>{ideaBackInfo.gmtCreate && moment(ideaBackInfo.gmtCreate).format('YYYY-MM-DD HH:mm:ss')}</span></p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.title}>问题描述</div>
                    <div>{ideaBackInfo.questionDesc}</div>
                    <div className={styles.title}>图片</div>
                    {ideaBackInfo.imageList && ideaBackInfo.imageList.map((i, index) => {
                        return <XMediaFn
                            key={index}
                            dataType='image'
                            dataSource={i}
                        />;
                    })}
                    <div style={{ clear: 'both' }}></div>
                    <div className={styles.title}>提交视频</div>
                    <XMediaFn
                        dataType='video'
                        dataSource={ideaBackInfo.videoList}
                    />
                    <div style={{ clear: 'both' }}></div>
                    <div className={styles.title}>处理状态: <span>{ideaBackInfo.processState}</span></div>
                    <div className={styles.title}>处理意见</div>
                    <div>
                        <Form {...formItemLayout} className="create-form" ref={this.formRef}
                            initialValues={{
                                processOpinion: ideaBackInfo.processOpinion
                            }}
                        >
                            <Form.Item
                                name='processOpinion'
                            >
                                <TextArea rows={4} />
                            </Form.Item>
                        </Form>

                    </div>
                </div>
            </Modal>
        );
    }
}

ProducDetails.propTypes = {
    title: PropTypes.string,// 弹框标题
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    history: PropTypes.object, // 路由history
    match: PropTypes.object,// 路由history
    data: PropTypes.object,
    ideaBackInfo: PropTypes.object,
    getideaBackInfo: PropTypes.func,
    refresh: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        ideaBackInfo: state.suggestions.ideaBackInfo || {},
    };

};
export default connect(mapStateToProps, { ...model.actions })(ProducDetails);